import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { UnauthCardComponent } from './components/unauth-card/unauth-card.component';
import { LoginPageComponent } from './containers/login-page/login-page.component';
import { PasswordResetRequestComponent } from './containers/password-reset-request/password-reset-request.component';
import { PasswordResetComponent } from './containers/password-reset/password-reset.component';
import { UnauthorizedInterceptor } from './services/unauthorized.interceptor';
import { DefaultRouteComponent } from './containers/default-route/default-route.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [LoginPageComponent, UnauthCardComponent, PasswordResetComponent, PasswordResetRequestComponent, DefaultRouteComponent],
  imports: [
    SharedModule,
    RouterModule.forChild([
      {
        path: 'login',
        component: LoginPageComponent,
        data: {
          title: 'Sign in | Glimpse',
        },
      },
      {
        path: 'password-reset/:token',
        component: PasswordResetComponent,
        data: {
          title: 'Password Reset | Glimpse',
        },
      },
      {
        path: 'password-reset',
        component: PasswordResetRequestComponent,
        data: {
          title: 'Password Reset | Glimpse',
        },
      },
    ]),
    TranslateModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UnauthorizedInterceptor,
      multi: true,
    },
  ],
})
export class AuthModule {}
